export type UsageColor = 'green' | 'yellow' | 'red';

export const getUsagePercentage = (used: number, total?: number) => {
  if (!total || total <= 0) return 0;
  return Math.min(Math.round((used / total) * 100), 100);
};

export const getUsageColor = (percentage: number): UsageColor => {
  if (percentage < 70) return 'green';
  if (percentage < 90) return 'yellow';
  return 'red';
};
